import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Users, Trophy } from "lucide-react";

export default function ClubCard({ club }) {
    return (
        <Link
            to={`/clubs/${club.id}`}
            data-testid={`club-card-${club.id}`}
            className="group block card-tu hover:border-orange-500/50 hover:shadow-[0_0_32px_rgba(234,88,12,0.15)] transition-all"
        >
            <div className="flex items-center gap-2 mb-3">
                <span className="chip border-orange-500/40 text-orange-500">{club.sport}</span>
                <span className="chip border-zinc-700 text-zinc-300">{club.level}</span>
            </div>
            <h3 className="font-display text-3xl tracking-tight mb-2 group-hover:text-orange-500 transition-colors">
                {club.name}
            </h3>
            <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-zinc-400 mb-4">
                <span className="inline-flex items-center gap-1.5">
                    <MapPin size={12} className="text-orange-500" />
                    {club.city} · {club.department}
                </span>
                <span className="inline-flex items-center gap-1.5">
                    <Users size={12} className="text-orange-500" />
                    {club.num_players} joueurs · {club.num_teams} équipes
                </span>
            </div>
            {club.needs && (
                <div className="border-l-2 border-orange-500/40 pl-3 text-sm text-zinc-300 mb-4">
                    <span className="text-[10px] uppercase tracking-widest text-zinc-500 block mb-0.5">
                        Besoin
                    </span>
                    {club.needs}
                </div>
            )}
            <div className="flex flex-wrap gap-1.5">
                {club.age_categories?.slice(0, 5).map((c) => (
                    <span key={c} className="chip border-zinc-800 text-zinc-300">
                        {c}
                    </span>
                ))}
                {club.colors?.slice(0, 3).map((c) => (
                    <span key={c} className="chip border-zinc-800 text-zinc-300 inline-flex items-center gap-1">
                        <span
                            className="w-2 h-2 rounded-full inline-block"
                            style={{ background: colorToHex(c) }}
                        />
                        {c}
                    </span>
                ))}
            </div>
            <div className="mt-4 text-xs uppercase tracking-widest text-orange-500 inline-flex items-center gap-2 group-hover:translate-x-1 transition-transform">
                <Trophy size={14} /> Sponsoriser ce club →
            </div>
        </Link>
    );
}

function colorToHex(name) {
    const m = {
        Bleu: "#3b82f6",
        Blanc: "#fafafa",
        Rouge: "#dc2626",
        Noir: "#18181b",
        Vert: "#16a34a",
        Jaune: "#eab308",
        Orange: "#ea580c",
        Violet: "#9333ea",
        Rose: "#ec4899",
        Gris: "#6b7280",
    };
    return m[name] || "#a1a1aa";
}
